import React, { useState } from 'react';
import DashboardHeader from "../Pages/DashboardHeader/DboardHeader";
import Sidebarcomp from "../Pages/Sidebar/Sidebar";
import "./Layout.css";
import DashboardpageComp from '../Component/Dashboard/Dashboard';
import CommunityComp from '../Component/Admin/Community/Community';
import AdminprofileComp from "../Component/Admin/Admin Profile/Adminprofile";
function LayoutComp() {
    const [isCollapsed, setIsCollapsed] = useState(false);

    const toggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };
    return ( 
        <>
        <div className='layout d-flex'>
        <Sidebarcomp isCollapsed={isCollapsed} onToggle={toggleSidebar} />
            <div className={`main-components d-flex flex-column ${isCollapsed ? 'full-width' : ''}`}>
         
                <CommunityComp></CommunityComp>
              
                
            </div>
        </div>
    </>
  );
}

export default LayoutComp;
